<template>
	<el-container id="paper">
		<div class="titBox" style="margin-bottom: 20px">
			<p class="tit">论文信息</p>
		</div>
		<div v-if="theses_my.length">
			<div class="steps">
        	    <el-steps :active="1" process-status="finish" align-center>
        	        <el-step icon="el-icon-upload" v-for="item in theses_data.steps" :key="item.id">
        	            <div slot="icon" class="step_icon" :class="item.id==step_id?'step_icon_select':''" @click="steps_fn(item)">
							<div class="current" v-if="item.id==theses_data.cur_step_id">当前阶段</div>
        	                <i class="iconfont" v-html="item.icon"></i>
        	            </div>
        	            <div slot="title" class="step_title" :class="item.id==step_id?'step_title_sele':''" >
        	                {{item.title}}
        	            </div>
        	        </el-step>
        	    </el-steps>
        	</div>
        	<div class="paper_box">
        	     <!-- :cell-class-name="tdClass" -->
        	      <!-- header-row-class-name="kbHead" -->
				<el-table v-if="table_data[0]&&table_data[0].code=='xuanti'" :data="table_data" stripe class="paper_tab" header-cell-class-name="paper_tab_head" v-loading="loading" border>
					<el-table-column prop="course_title" align="center" class-name="title" label="论题">
        	            <template slot-scope="scope">
							<div class="remark_text" @click="open_text(scope.row.record.student?scope.row.record.student.extra.title:'-')">
								{{scope.row.record.student?scope.row.record.student.extra.title:'-'}}
							</div>
						</template>
        	        </el-table-column>
					<el-table-column prop="course_code" align="center" label="研究方向" width="130">
        	            <template slot-scope="scope">
							<div class="remark_text" @click="open_text(scope.row.record.student?scope.row.record.student.extra.research_direction:'-')">
								{{scope.row.record.student?scope.row.record.student.extra.research_direction:'-'}}
							</div>
						</template>
        	        </el-table-column>
					<el-table-column prop="study_score" align="center" label="关键词" width="100">
        	            <template slot-scope="scope">
        	                {{scope.row.record.student?scope.row.record.student.extra.keyword:''}}
						</template>
        	        </el-table-column>
					<el-table-column prop="study_time1" align="center" label="答辩方式" width="100">
        	            <template slot-scope="scope">
        	                {{scope.row.record.student?(thesis_type_text[scope.row.record.student.extra.thesis_type]):'-'}}
						</template>
        	        </el-table-column>
					<el-table-column prop="jindu" align="center" label="论题审核状态" width="180">
        	            <template slot-scope="scope">
        	                {{scope.row.record.teacher?(scope.row.record.teacher.result==1?'通过':'驳回'):'-'}}
						</template>
        	        </el-table-column>
					<el-table-column prop="termTxt" align="center" label="审核人" width="180">
						<template slot-scope="scope">
							<div v-if="scope.row.record.teacher">
                                <div v-if="scope.row.record.teacher.creater.signature">
									 <el-image
        								ref="Imgs"
        								:src="imgurl+scope.row.record.teacher.creater.signature"
        								:preview-src-list="[imgurl+scope.row.record.teacher.creater.signature]"
        								@click.stop="handlePreviewClose"
        								class="alarm_img"
        							/>
									<!-- <img style="width: 100%;cursor: pointer;" :src="imgurl+scope.row.record.teacher.creater.signature" alt="" @click="open_url(imgurl+scope.row.record.teacher.creater.signature)"> -->
                                </div>
                                <span v-else>{{scope.row.record.teacher.creater.name}}</span>
                            </div>
						</template>
					</el-table-column>
        	        <el-table-column prop="termTxt" align="center" label="审核时间" width="180">
						<template slot-scope="scope">
							{{scope.row.record.teacher?scope.row.record.teacher.created_at:'-'}}
						</template>
					</el-table-column>
        	        <el-table-column prop="termTxt" align="center" label="操作" width="180">
        	            <template slot-scope="scope">
        	                <el-button type="text" v-if="scope.row.is_finished==2" size="small" @click="open_thesis_records_visible(scope.row)">提交</el-button>
							<el-button type="text" v-else size="small" disabled>提交</el-button>
        	                <el-button type="text" size="small" @click="download(scope.row.record.teacher.attachment.url)" v-if="scope.row.record.teacher&&scope.row.record.teacher.attachment.url">下载指导文件</el-button>
							<el-button type="text" size="small" v-else disabled>下载指导文件</el-button>
        	            </template>
        	        </el-table-column>
				</el-table>
				<el-table v-else :data="table_data" stripe class="paper_tab" header-cell-class-name="paper_tab_head" v-loading="loading" border>
					<el-table-column prop="course_title" align="center" class-name="title" label="上传时间" width="180">
        	            <template slot-scope="scope">
        	                {{scope.row.record.student?scope.row.record.student.updated_at:'-'}}
						</template>
        	        </el-table-column>
					<el-table-column prop="jindu" align="center" label="指导状态" width="100">
        	            <template slot-scope="scope">
        	                {{scope.row.record.teacher?(scope.row.record.teacher.result==1?'通过':'驳回'):'-'}}
						</template>
        	        </el-table-column>
					<el-table-column prop="termTxt" align="center" label="指导人" width="100">
						<template slot-scope="scope">
							{{scope.row.record.teacher?scope.row.record.teacher.creater.name:'-'}}
						</template>
					</el-table-column>
        	        <el-table-column prop="termTxt" align="center" label="指导时间" width="180">
						<template slot-scope="scope">
							{{scope.row.record.teacher?scope.row.record.teacher.updated_at:'-'}}
						</template>
					</el-table-column>
					<el-table-column prop="termTxt" align="center" label="指导意见">
						<template slot-scope="scope">
							<div class="remark_text" @click="open_text(scope.row.record.teacher?scope.row.record.teacher.remark:'-')">
								{{scope.row.record.teacher?scope.row.record.teacher.remark:'-'}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="termTxt" align="center" label="是否评定">
						<template slot-scope="scope">
							{{scope.row.record.teacher?(scope.row.record.teacher.extra&&scope.row.record.teacher.extra.is_end==1?'是':'否'):'-'}}
						</template>
					</el-table-column>
					<el-table-column prop="termTxt" align="center" label="评定成绩">
						<template slot-scope="scope">
							{{scope.row.record.teacher?(scope.row.record.teacher.extra&&scope.row.record.teacher.extra.is_end==1?scope.row.record.teacher.extra.score:'-'):'-'}}
						</template>
					</el-table-column>
					<el-table-column prop="termTxt" align="center" label="指导意见">
						<template slot-scope="scope">
							<div class="remark_text" @click="open_text(scope.row.record.teacher?scope.row.record.teacher.remark:'-')">
								{{scope.row.record.teacher?scope.row.record.teacher.remark:'-'}}
							</div>
						</template>
					</el-table-column>
					
        	        <el-table-column prop="termTxt" align="center" label="操作" width="270">
        	            <template slot-scope="scope">
        	                <el-button type="text" v-if="scope.row.is_finished==2&&scope.row.is_locked==2" size="small" @click="open_records_visible(scope.row)">提交</el-button>
							<!-- <el-button type="text" v-else size="small" disabled>提交</el-button> -->
        	                <el-button type="text" size="small" @click="download(scope.row.record.teacher.attachment.url)" v-if="scope.row.record.teacher&&scope.row.record.teacher.attachment.url">下载指导文件</el-button>
							<el-button type="text" size="small" v-else disabled>下载指导文件</el-button>
							<el-button type="text" size="small" @click="download(scope.row.record.student.attachment.url)" v-if="scope.row.record.student&&scope.row.record.student.attachment.url">下载提交文件</el-button>
							<el-button type="text" size="small" v-else disabled>下载提交文件</el-button>
        	            </template>
        	        </el-table-column>
				</el-table>
				<div class="illustrate">
					<el-button type="primary" size="small" style="margin-top: 20px; margin-bottom: 10px;" @click="illustratedialogVisible=true">新增说明</el-button>
					<el-table :data="illustrate_data" stripe class="paper_tab" header-cell-class-name="paper_tab_head" v-loading="loading" border>
						<el-table-column prop="con" align="center" class-name="title" label="内容">
        	    	        <!-- <template slot-scope="scope">
								<div class="remark_text" @click="open_text(scope.row.record.student?scope.row.record.student.extra.title:'-')">
									{{scope.row.record.student?scope.row.record.student.extra.title:'-'}}
								</div>
							</template> -->
        	    	    </el-table-column>
						<el-table-column prop="time" align="center" label="提交时间" width="150"></el-table-column>
						<el-table-column prop="name" align="center" label="提交人" width="120"></el-table-column>
						<el-table-column prop="u_time" align="center" label="修改时间" width="150"></el-table-column>

        	    	    <el-table-column prop="termTxt" align="center" label="操作" width="180">
        	    	        <template slot-scope="scope">
        	    	            <el-button type="text"  size="small" @click="illustratedialogVisible=true">编辑</el-button>
        	    	        </template>
        	    	    </el-table-column>
					</el-table>
				</div>
			</div>
		</div>
        <div class="nodata" v-else>
			<img :src="nodataImg">
			<p>待更新</p>
		</div>
        
		<el-dialog title="提交" :visible.sync="records_visible">
            <el-form :model="thesis_records_data" :label-width="formLabelWidth">
                <el-form-item label="意见">
                    <el-input type="textarea" v-model="thesis_records_data.remark" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="文件上传">
                     <el-input v-model="imgsrc1" autocomplete="off" disabled style="margin-right: 10px;"></el-input>
                     <el-button type="primary" @click="selectImage1">点击上传</el-button>
                    <input type="file" ref="file" @change="change1" v-show="false"/>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="records_visible = false">取 消</el-button>
                <el-button type="primary" @click="records_fn">确 定</el-button>
            </div>
        </el-dialog>


        <el-dialog title="提交选题" :visible.sync="thesis_records_visible">
            <el-form :model="extra" :label-width="formLabelWidth" :rules="thesis_rules" ref="thesis_rul_form">
                <el-form-item label="论题" prop="title">
                    <el-input v-model="extra.title" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="研究方向" prop="research_direction">
                    <el-input v-model="extra.research_direction" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="关键词" prop="keyword">
                    <el-input v-model="extra.keyword" autocomplete="off"></el-input>
                </el-form-item>
                <!-- :label-width="formLabelWidth" -->
                <el-form-item label="论文类型">
                    <el-select v-model="extra.thesis_type" placeholder="请选择论文类型">
						<!-- <el-option label="未定" value="0"></el-option> -->
                        <el-option label="普通论文" value="1"></el-option>
                        <el-option label="学位论文" value="2"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="thesis_records_visible = false">取 消</el-button>
                <el-button type="primary" @click="thesis_fn()">确 定</el-button>
            </div>
        </el-dialog>

		<!-- 新增说明 -->
		<el-dialog title="说明" :visible.sync="illustratedialogVisible" width="40%" class="taolunduihua" :close-on-click-modal="false">
			<el-input v-model="content" style="width:100%;color:red;" placeholder="内容" type="textarea" :rows="12" class="nei"></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="illustratedialogVisible=false">完成</el-button>
			</span>
		</el-dialog>
	</el-container>
</template>

<script>
export default {
	name: 'paper'
	,data () {
		return {
			imgurl:this.global.oss_link,
            thesis_records_visible:false,
			records_visible:false,
            table_data:[],
            theses_data:{
		        "steps": [
		        	{
                        "id":1,
		        		"title": "选题",
		        		"is_start": 1,
		        		"is_end": 1,
		        		"must_finished": 1,
		        		"is_finished": 1,
		        		"icon": "&#xe6c1;",
		        		"is_locked": 1,
		        		"next_operate": 1
		        	},
                    {
                        "id":2,
		        		"title": "开题报告",
		        		"is_start": 1,
		        		"is_end": 1,
		        		"must_finished": 1,
		        		"is_finished": 1,
		        		"icon": "&#xe6b5;",
		        		"is_locked": 1,
		        		"next_operate": 1
		        	},
                    {
                        "id":3,
		        		"title": "初稿",
		        		"is_start": 1,
		        		"is_end": 1,
		        		"must_finished": 1,
		        		"is_finished": 1,
		        		"icon": "&#xe6b5;",
		        		"is_locked": 1,
		        		"next_operate": 1
		        	},
                    {
                        "id":4,
		        		"title": "复稿",
		        		"is_start": 1,
		        		"is_end": 1,
		        		"must_finished": 1,
		        		"is_finished": 1,
		        		"icon": "&#xe6b5;",
		        		"is_locked": 1,
		        		"next_operate": 1
		        	},
                    {
                        "id":5,
		        		"title": "终稿",
		        		"is_start": 1,
		        		"is_end": 1,
		        		"must_finished": 1,
		        		"is_finished": 1,
		        		"icon": "&#xe6b5;",
		        		"is_locked": 1,
		        		"next_operate": 1
		        	}
		        ],

            },
            loading:false,
			thesis_type_text:{
				0:'未定',
				1:'普通论文',
				2:'学位论文'
			},
            thesis_records_data:{
                result: 1,
                remark: "",
            },
            //上传文件
            attachment: {
	        	title: "",
	        	url: ""
	        },
            //扩展数据
            extra: {
	        	title: "",
	        	research_direction: "",
	        	keyword: "",
	        	thesis_type: '0'
	        },
            imgsrc1:'',
            formLabelWidth:'80px',
            thesis_rules:{
                title: [
                    { required: true, message: '请输入论题', trigger: 'blur' },
                ],
                research_direction: [
                    { required: true, message: '请输入研究方向', trigger: 'blur' },
                ],
                keyword: [
                    { required: true, message: '请输入关键词', trigger: 'blur' },
                ],
                // thesis_type: [
                //     { required: true, message: '请输入关键词', trigger: 'change' },
                // ],
            },
			theses_my:[],
			step_id:'',
			illustrate_data:[ //说明列表
				{con:'-',time:'-',name:'-',u_time:'-'}
			],
			content:'',
			illustratedialogVisible:false  //说明框
		}
	}
	,mounted:function(){
		this.get_theses_my()
	}
	,methods:{
		//清空数据
		del_data(){
			this.attachment = {
				title: "",
	        	url: ""
			}
			this.extra = {
				title: "",
	        	research_direction: "",
	        	keyword: "",
	        	thesis_type: '0'
			}
			this.thesis_records_data = {
				result: 1,
                remark: "",
			}
			this.imgsrc1 = ''
		},
        open_thesis_records_visible(){
            // console.log(data);
			if (this.table_data[0].record.student) {
				this.extra = this.table_data[0].record.student.extra
			}else{
				this.del_data()
			}
            this.thesis_records_visible = true
        },
		open_records_visible(){
			if (this.table_data[0].record.student) {
				this.thesis_records_data.remark = this.table_data[0].record.student.remark
				this.attachment = this.table_data[0].record.student.attachment
				this.imgsrc1 = this.global.oss_link+this.table_data[0].record.student.attachment.url
			}else{
				this.del_data()
			}
            this.records_visible = true
		},
        selectImage1(){
            this.$refs.file.click();
        },
        change1(event) {
            let file = event.target.files[0];
            this.imgChange(file)
        },
        // 上传阿里云
        async imgChange (file) {
            // console.log(file);
            let that = this
            if(file==undefined){return false}
            if(file.size > 104857600){
				this.$alert('文件大小不能超过100MB', '信息提示', {
					confirmButtonText: '确定'
				})
                return false
			}
            const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
            //验证通过，上传文件
            let flname = this.$selfjs.createOssFileName()
			let upload_path = `xuexi.qsxueli.com/uploadFile/paper/${flname}.${file.name.substring(file.name.lastIndexOf(".")+1)}`;
			this.$ajax.post(this.global.serverSrc + this.global.qianzui +"/aliyun/upload_token",this.$qs.stringify({dir:'xuexi.qsxueli.com/uploadFile/paper'}))
		    .then(res=>{
				let resData = res.data
				if(resData.code==0){
					let oss_data = new FormData()
					oss_data.append("key",upload_path);
 					oss_data.append("policy", resData.data.policy);
 					oss_data.append("OSSAccessKeyId", resData.data.accesskeyid);
 					oss_data.append("success_action_status", '200');
 					oss_data.append("signature", resData.data.signature);
 					oss_data.append("file", file, file.name);
					
					this.$ajax.post(this.global.oss_link,oss_data).then(res=>{
						console.log(res);
						if (res.ok) {
                            loading.close()
							that.attachment = {
                                title: file.name.substring(0, file.name.lastIndexOf(".")),
	        	                url: upload_path
                            }
                            that.imgsrc1 = that.global.oss_link+upload_path
                            this.$message.success('上传成功')
                            console.log(that.attachment);
						}else{
							that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
								confirmButtonText: '确定',
							});
						}
					})
				}else{
                    loading.close()
					that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
						confirmButtonText: '确定',
					});
					this.$message.error(resData.message)
				}
		    }).catch(_ => {
				that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
					confirmButtonText: '确定',
				});
				// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
				loading.close()
			});
        },
		// 获取我的论文列表
		get_theses_my(){
			const loading = this.$loading({
        	  	lock: true,
        	  	text: 'Loading',
        	  	spinner: 'el-icon-loading',
        	  	background: 'rgba(0, 0, 0, 0.7)'
        	});
			let serverSrc = this.global.serverSrc,
				qianzui = this.global.qianzui
			this.$ajax.get(serverSrc + qianzui +"/theses/my")
			.then((res)=>{
				loading.close();
				let resData=res.data;
				if(resData.code==0){
					this.theses_my = resData.data.data
					if (this.theses_my.length) {
						this.get_theses_data()
					}
				}else{
					this.$message.error(resData.message)
					// console.log(resData.message);
				}
			})
		},
		//获取论文详情
		get_theses_data(){
			const loading = this.$loading({
        	  	lock: true,
        	  	text: 'Loading',
        	  	spinner: 'el-icon-loading',
        	  	background: 'rgba(0, 0, 0, 0.7)'
        	});
			let serverSrc = this.global.serverSrc,
				qianzui = this.global.qianzui
				
			this.$ajax.get(serverSrc + qianzui +"/theses/"+this.theses_my[0].id)
			.then((res)=>{
				loading.close();
				let resData=res.data;
				// console.log(resData);
				if(resData.code==0){
					this.theses_data = resData.data
					this.step_id = this.theses_data.cur_step_id
					this.get_table_data()
				}else{
					this.$message.error(resData.message)
					// console.log(resData.message);
				}
			})
		},
		//获取步骤详情
        get_table_data(){
			this.loading = true
			let serverSrc = this.global.serverSrc,
				qianzui = this.global.qianzui
				
			this.$ajax.get(serverSrc + qianzui +"/thesis_steps/record_detail",{
				params:{
					step_id:this.step_id
				}
			})
			.then((res)=>{
				this.loading = false
				let resData=res.data;
				// console.log(resData);
				if(resData.code==0){
					this.table_data = [resData.data]
					// console.log(this.table_data);
				}else{
					this.$message.error(resData.message)
					// console.log(resData.message);
				}
			})
		},
		//下载文件
		download(url){
			window.open(this.global.oss_link + url)
		},
		thesis_records(){
			const loading = this.$loading({
        	  	lock: true,
        	  	text: 'Loading',
        	  	spinner: 'el-icon-loading',
        	  	background: 'rgba(0, 0, 0, 0.7)'
        	});
			let serverSrc = this.global.serverSrc,
				qianzui = this.global.qianzui
				
			this.$ajax.post(serverSrc + qianzui +"/thesis_records",{
				...this.thesis_records_data,
				thesis_id:this.table_data[0].thesis_id,
				step_id:this.table_data[0].id,
				extra:this.extra,
				attachment:this.attachment
			})
			.then((res)=>{
				this.loading = false
				let resData=res.data;
				loading.close();
				// console.log(resData);
				if(resData.code==0){
					this.$message.success('上传成功')
					this.get_theses_my()
					this.thesis_records_visible = false
					this.records_visible = false
					// this.table_data = [resData.data]
					// console.log(this.table_data);
				}else{
					this.$message.error(resData.message)
					// console.log(resData.message);
				}
			})
		},
		//提交选题
		thesis_fn(){
			this.$refs.thesis_rul_form.validate((valid) => {
        		if (valid) {
					this.thesis_records()
        		} else {
        			// console.log('error submit!!');
        			return false;
        		}
        	});
		},
		//上传文件
		records_fn(){
			if (!this.attachment.url) {
				this.$message.error('请上传文件！')
				return false
			}
			this.thesis_records()
		},
		//步骤选择
        steps_fn(item){
            //if (item.is_finished==1||item.id==this.theses_data.cur_step_id) {
                // console.log(item);
                this.step_id = item.id
                this.get_table_data()
            //}
        },
		//打开文本
		open_text(text){
			if (text) {
				this.$alert(text, '查看', {
					showConfirmButton:false,
        		});
			}
		},
		//图片预览关闭
 		async handlePreviewClose() {
 		  	// await this.$nextTick();
 		  	// //获取ui库弹出的dom
 		  	// let domImageMask = document.querySelector(".el-image-viewer__img");
 		  	// if (!domImageMask) {
 		  	//   return;
 		  	// }
 		  	// //模拟点击右上角的close
 		  	// domImageMask.addEventListener("click", () => {
 		  	//   document.querySelector(".el-image-viewer__close").click();
 		  	// });
 		},
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/renwu/paper.vue